import { useState, useEffect } from 'react';

// Listen to resize events and pass this on to components that need this.
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(
    { width: window.innerWidth, height: window.innerHeight },
  );
  useEffect(() => {
    const resizeListener = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', resizeListener);
    return () => window.removeEventListener('resize', resizeListener);
  }, []);
  return windowSize;
};

export default useWindowSize;
